/* eslint-disable @typescript-eslint/no-explicit-any */
import { getDataValue, setDataValue } from '@juvare/json-data-util';
export function formatWidgetConfig(widgets, config) {
    const formattedConfig = JSON.parse(JSON.stringify(config));
    formatWidgetConfigRecursive(widgets, formattedConfig);
    return formattedConfig;
}
function formatWidgetConfigRecursive(widgets, config) {
    const widget = widgets.find((w) => w.type === config.type);
    const configCopy = Object.assign({}, config);
    delete configCopy['_internal_id_'];
    delete configCopy['_internal_new_'];
    delete configCopy['_internal_path_id_'];
    Object.keys(config).forEach((key) => delete config[key]);
    config.type = configCopy.type;
    if (configCopy.key != null) {
        config.key = configCopy.key;
    }
    if (widget && widget.formatConfig) {
        for (const field of widget.formatConfig) {
            const value = getDataValue(configCopy, field.path);
            if (value != null && (field.defaultValue == null || field.defaultValue !== value)) {
                setDataValue(config, field.path, value);
            }
        }
    }
    else {
        Object.assign(config, configCopy);
    }
    if (widget && widget.childConfigs) {
        widget.childConfigs(config).forEach((childConfig) => formatWidgetConfigRecursive(widgets, childConfig));
    }
}
